<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <el-form :inline="true">
        <el-form-item :label="this.$t('announcement.createdDate')">
          <el-date-picker class="pickData_cla"
                          v-model="value1"
                          type="daterange"
                          align="right"
                          unlink-panels
                          range-separator="-"
                          :start-placeholder="this.$t('announcement.beginTime')"
                          :end-placeholder="this.$t('announcement.endTime')"
                          :default-time="['00:00:00', '23:59:59']"></el-date-picker>
        </el-form-item>
        <el-form-item :label="this.$t('announcement.validDate')"
                      v-if="hasPermission('1d676727cd7e4b429cd75e66db4c771b')">
          <el-date-picker class="pickData_cla"
                          v-model="value2"
                          type="daterange"
                          align="right"
                          unlink-panels
                          range-separator="-"
                          :start-placeholder="this.$t('announcement.effectTime')"
                          :end-placeholder="this.$t('announcement.expirationTime')"
                          :default-time="['00:00:00', '23:59:59']"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="query">{{$t('common.search')}}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="black_panel_cla">
      <div class="header-button-bar">
        <zk-tool-bar @addAnnouncement="addAnnouncement"
                     ref="addAnnouncementReset"></zk-tool-bar>
      </div>

      <el-table :data="data"
                :row-key="getRowKeys"
                style="width: 100%">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="title"
                         :label="this.$t('announcement.title')">
          <template slot-scope="scope">
            <el-popover trigger="hover"
                        placement="bottom">
              <p>{{ scope.row.title }}</p>
              <div slot="reference"
                   class="name-wrapper">
                <div class="text_overflow">{{ scope.row.title }}</div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="content"
                         :label="this.$t('announcement.content')">
          <template slot-scope="scope">
            <el-popover trigger="hover"
                        placement="bottom">
              <p>{{ scope.row.content }}</p>
              <div slot="reference"
                   class="name-wrapper">
                <div class="text_overflow">{{ scope.row.content }}</div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="createdBy"
                         :label="this.$t('announcement.createdBy')"
                         v-if="hasPermission('1d676727cd7e4b429cd75e66db4c771b')"></el-table-column>
        <el-table-column prop="releaseDate"
                         :label="this.$t('announcement.createdDate')">
          <template slot-scope="scope">
            <span v-if="scope.row.releaseDate">
              {{ scope.row.releaseDate | dataFormat }}
            </span>
            <span v-else>N/A</span>
          </template>
        </el-table-column>
        <el-table-column prop="validDate"
                         :label="this.$t('announcement.validDate')"
                         v-if="hasPermission('1d676727cd7e4b429cd75e66db4c771b')">
          <template slot-scope="scope">{{
            scope.row.validDate | dataFormat | toDay
          }}</template>
        </el-table-column>
        <el-table-column prop="status"
                         :label="this.$t('announcement.status')"
                         v-if="hasPermission('1d676727cd7e4b429cd75e66db4c771b')">
          <template slot-scope="scope">
            <span v-if="scope.row.status"
                  style="color: @themeColor">
              {{ $t('announcement.annRelease') }}
            </span>
            <span v-else>{{ $t('announcement.annNotRelease') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('common.action')"
                         width="200"
                         align="center">
          <template slot-scope="scope">
            <span class="btn-text-cla"
                  @click.stop="edit(scope.row)"
                  v-if="hasPermission('1d676727cd7e4b429cd75e66db4c771b')">{{ $t('common.edit') }}</span>
            <span class="btn-text-cla"
                  @click.stop="detail(scope.row)">{{
              $t('common.details')
            }}</span>
            <span class="btn-text-cla"
                  v-if="
                hasPermission('1d676727cd7e4b429cd75e66db4c771b') &&
                scope.row.status !== 1
              "
                  @click.stop="release(scope.row)">{{ $t('common.release') }}</span>
            <span class="btn-text-cla"
                  v-if="hasPermission('1d676727cd7e4b429cd75e66db4c771b')"
                  @click.stop="remvoe(scope.row)">{{ $t('common.delete') }}</span>

          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-margin-top">
        <el-pagination background
                       @size-change="pageSizeChange(arguments[0], commQuery)"
                       @current-change="curPageChange(arguments[0], commQuery)"
                       :current-page="pager.curPage"
                       :page-size="pager.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pager.total"></el-pagination>
      </div>
    </div>

    <el-dialog :title="title"
               :visible.sync="dialogVisible"
               width="45%"
               @close="handleClose">
      <el-form :model="form"
               :rules="formRules"
               ref="annoucement"
               label-position="left">
        <el-form-item :label="this.$t('announcement.title')"
                      :label-width="formLabelWidth"
                      prop="title">
          <el-row>
            <el-col :span="20">
              <el-input :placeholder="this.$t('common.enterValue')"
                        v-model="form.title"
                        maxlength="50"
                        :disabled="isView ? true : false"></el-input>
            </el-col>
            <el-col :span="4"
                    align="center">
              <span :style="tilteLength === 50 ? 'color:red' : ''">{{ tilteLength }}/50</span>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="this.$t('announcement.content')"
                      :label-width="formLabelWidth"
                      prop="content">
          <el-row style="position: relative">
            <el-col :span="20">
              <el-input type="textarea"
                        :rows="8"
                        maxlength="500"
                        :placeholder="this.$t('common.enterValue')"
                        v-model="form.content"
                        :disabled="isView ? true : false"></el-input>
            </el-col>
            <el-col :span="4"
                    style="position: absolute; bottom: -10px; right: 0"
                    align="center">
              <span :style="contentLength === 500 ? 'color:red' : ''">{{ contentLength }}/500</span>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="this.$t('announcement.validDate')"
                      :label-width="formLabelWidth"
                      prop="validDate"
                      v-if="!isView">
          <el-row>
            <el-col :span="20">
              <el-date-picker v-model="form.validDate"
                              type="date"
                              :placeholder="this.$t('announcement.choiceTime')"
                              style="width:100%"></el-date-picker>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="this.$t('annList.sendEmail')"
                      label-width="140px"
                      v-if="hasPermission('1d676727cd7e4b429cd75e66db4c771b')">
          <el-row>
            <el-col :span="12">
              <el-checkbox-group v-model="checkList"
                                 v-if="form.status"
                                 :disabled="isView ? true : false">
                <el-checkbox label="developer"
                             disabled>
                  {{ $t('annList.dev') }}
                </el-checkbox>
                <el-checkbox label="enterpriseadmin">
                  {{ $t('annList.ent') }}
                </el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="this.$t('announcement.announcementStatus')"
                      :label-width="formLabelWidth"
                      prop="status"
                      v-if="!isView">
          <el-row>
            <el-col :span="4">
              <el-switch v-model="form.status"
                         active-color="#13ce66"
                         inactive-color="#cccccc"
                         :active-value="1"
                         :inactive-value="0"></el-switch>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary"
                   @click="sumbitAnnoucement"
                   v-if="!isView">
          {{ $t('common.confirm') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as annoService from '../../../services/announcement'
import { getStartTime } from '../../../utils/utils.js'
// import { getAnnNumber } from '@/services/announcement.js'
export default {
  data () {
    let titleRule = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('announcement.inputTitle')))
      } else if (value.length > 50) {
        callback(new Error(this.$t('announcement.titleMaxLength')))
      } else {
        callback()
      }
    }
    let contentRule = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('announcement.inputContent')))
      } else if (value.length > 500) {
        callback(new Error(this.$t('announcement.contentMaxLength')))
      } else {
        callback()
      }
    }
    return {
      value1: [],
      value2: [],
      data: [],
      title: '',
      dialogVisible: false,
      formLabelWidth: '140px',
      form: {
        content: '',
        validDate: '',
        title: '',
        status: 1
      },
      formRules: {
        title: [
          { required: true, validator: titleRule, trigger: ['blur', 'change'] }
        ],
        content: [
          {
            required: true,
            validator: contentRule,
            trigger: ['blur', 'change']
          }
        ],
        time: [
          {
            required: true,
            message: this.$t('announcement.inputTime'),
            trigger: ['blur', 'change']
          }
        ]
      },
      tilteLength: 0,
      contentLength: 0,
      isUpdate: false,
      isView: false,
      rowId: '',
      checkList: ['developer'],
      row: []
    }
  },
  inject: ['getTotal'],
  watch: {
    'form.title': {
      handler: function (val, oval) {
        if (val) {
          this.tilteLength = val.length
        }
      }
    },
    'form.content': {
      handler: function (val, oval) {
        if (val) {
          this.contentLength = val.length
        }
      }
    }
  },
  filters: {
    toDay (time) {
      if (time) {
        return time.substr(0, 10)
      } else {
        return 'N/A'
      }
    }
  },
  methods: {
    sumbitAnnoucement () {
      this.$refs.annoucement.validate((valid) => {
        if (valid) {
          if (this.isUpdate) {
            this.form.validDate =
              getStartTime(this.form.validDate) + 24 * 60 * 60 * 1000 - 1
            let params = {
              id: this.rowId,
              roleIds: this.checkList.toString(),
              ...this.form
            }
            annoService
              .update(params)
              .then((data) => {
                if (data.code === '00000000') {
                  this.$message.success(this.$t('operationMsg.updateSuc'))
                  this.query()
                  this.handleClose()
                } else {
                  this.$message.error(data.message)
                }
              })
              .catch((e) => { })
          } else {
            this.form.validDate =
              this.form.validDate.getTime() + 24 * 60 * 60 * 1000 - 1
            this.form.roleIds = this.checkList.toString()
            annoService
              .add(this.form)
              .then((data) => {
                if (data.code === '00000000') {
                  this.$message.success(this.$t('operationMsg.addSuc'))
                  this.query()
                  this.handleClose()
                } else {
                  this.$message.error(data.message)
                }
              })
              .catch((e) => { })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    remvoe (row) {
      this.$confirm(
        this.$t('announcement.deleteSure'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          annoService
            .remove({
              id: row.id
            })
            .then((data) => {
              if (data.code === '00000000') {
                this.getTotal()
                this.$message({
                  type: 'success',
                  message: this.$t('common.successDelete')
                })
                this.query()
              } else {
                this.$message.error(data.message)
              }
            })
            .catch((e) => { })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },
    release (row) {
      this.$confirm(
        this.$t('annList.sureRelase'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          annoService
            .release({
              id: row.id
            })
            .then((data) => {
              if (data.code === '00000000') {
                this.$message({
                  type: 'success',
                  message: this.$t('announcement.releaseSuccess')
                })
                this.query()
              } else {
                this.$message.error(data.message)
              }
            })
            .catch((e) => { })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },
    detail (row) {
      this.dialogVisible = true
      this.title = this.$t('announcement.announcementDetal')
      this.isView = true
      this.form.title = row.title
      this.form.content = row.content
      this.checkList = row.roleList
      this.row = row
    },
    edit (row) {
      this.dialogVisible = true
      this.title = this.$t('announcement.modifyAnnouncemnet')
      this.isUpdate = true
      this.form.content = row.content
      this.form.validDate = row.validDate
      this.form.title = row.title
      this.form.status = row.status
      this.rowId = row.id
      this.checkList = row.roleList
    },
    addAnnouncement () {
      this.dialogVisible = true
      this.title = this.$t('announcement.addAnnouncement')
      this.isUpdate = false
      this.checkList = ['developer']
    },
    handleClose () {
      this.dialogVisible = false
      this.form.title = ''
      this.form.content = ''
      this.form.validDate = ''
      this.form.status = 1
      this.rowId = ''
      this.tilteLength = 0
      this.contentLength = 0
      if (this.isView) {
        if (!this.row.isRead) {
          annoService
            .setToReadAnn({
              announcementId: this.row.id
            })
            .then((data) => {
              if (data.code === '00000000') {
                this.getTotal()
                this.commQuery()
              }
            })
            .catch((e) => { })
        }
      } else {
        this.getTotal()
      }
      let s = setTimeout(() => {
        this.isView = false
        clearTimeout(s)
      }, 300)
      this.checkList = ['checkList']
    },

    commQuery () {
      let params = {
        beginTime: '',
        endTime: '',
        beginValidTime: '',
        endValidTime: ''
      }
      if (this.value1 && this.value1.length === 2) {
        params.beginTime = Date.parse(this.value1[0])
        params.endTime = Date.parse(this.value1[1]) + 1000 - 1
      }
      if (this.value2 && this.value2.length === 2) {
        params.beginValidTime = Date.parse(this.value2[0])
        params.endValidTime = Date.parse(this.value2[1]) + 1000 - 1
      }
      annoService
        .list({
          pager: this.pager,
          params: params
        })
        .then((data) => {
          if (data.code === '00000000') {
            this.data = data.payload.results.results || data.payload.results
            this.pager.pageSize =
              data.payload.pageSize || data.payload.results.pageSize
            this.pager.curPage =
              data.payload.curPage || data.payload.results.curPage
            this.pager.total =
              data.payload.totalRecords || data.payload.results.totalRecords
          } else {
            this.$message.error(data.message)
          }
        })
        .catch((e) => { })
    },
    query () {
      this.pager.curPage = 1
      this.commQuery()
    },
    getRowKeys (row) {
      return row.id
    }
  },
  mounted () {
    this.query()
  }
}
</script>

<style lang="less" scoped>
.annoucement_cla {
  padding: 10px;
  background: #fff;
  .text_overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .detailRow {
    margin-top: 10px;
    line-height: 1.7;
    .detail_lab {
      display: inline-block;
      color: #333333;
      width: 60px;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/zkCdpPage/message/announcement.vue